// removed by extract-text-webpack-plugin
module.exports = {"backImg":"_3e1GqadWL7tCy6Wio_wuId"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DetailBigCarousel/DetailBigCarousel.scss
 ** module id = 960
 ** module chunks = 0
 **/